import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PassAuditLogData, PassFieldName } from '../../api';
import { formatSignedNumber } from '../../passes/management/utils';

export const PunchAdjustmentAuditDetails = ({ log }: { log: PassAuditLogData }) => {
  const { t } = useTranslation();
  const change = log.changes?.find((item) => item.field_name === PassFieldName.NUM_PUNCHES);
  const oldTotal = Number(change?.old_value);
  const newTotal = Number(change?.new_value);
  const delta = newTotal - oldTotal;

  return (
    <Box
      sx={{
        mt: 0.5,
        p: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '6px',
        maxWidth: 480,
      }}>
      {Number.isFinite(delta) && (
        <Typography variant="body2" fontWeight={600}>
          {t('auditlog.punches_adjusted.change', {
            old: oldTotal,
            new: newTotal,
            // LRI/PDI isolate keeps the sign order in RTL
            delta: `\u2066${formatSignedNumber(delta)}\u2069`,
          })}
        </Typography>
      )}
      {log.reason && (
        <Typography variant="body2">
          <Typography variant="body2" color="text.secondary" component="span">
            {t('auditlog.punches_adjusted.reason')}:
          </Typography>{' '}
          {log.reason}
        </Typography>
      )}
    </Box>
  );
};
